module.exports = __webpack_public_path__ + "img/accounting-calculator-2.eaac7436.svg";